export enum DocumentType {
  CPF,
  RG,
  CNPJ,
  IE,
  IM,
  Custom
}

export interface Document {
  type: DocumentType
  value?: string
}

export enum LegalEntityDocumentType {
  CPF = 'cpf',
  CNPJ = 'cnpj'
}
